import { CustomerSettingsMessage } from '../../../types/CustomerSettingsMessage';
import { useRole } from '../../common/hooks/useRole';
import { OfferModel } from '../model/OfferModel';

import { AdminOfferDetailStatusBar } from './AdminOfferDetailStatusBar';
import { StateSwitchContextProvider } from './common/components/StateSwitchContextProvider';
import { CustomerOfferDetailStatusBar } from './CustomerOfferDetailStatusBar';
import { SupplierOfferDetailStatusBar } from './SupplierOfferDetailStatusBar';

interface OfferDetailStatusBarProps {
    offer: OfferModel;
    customerSettings: CustomerSettingsMessage;
}

export const OfferDetailStatusBar = ({ offer, customerSettings }: OfferDetailStatusBarProps) => {
    const role = useRole();

    if (role.isCustomer()) {
        return (
            <StateSwitchContextProvider>
                <CustomerOfferDetailStatusBar offer={offer} customerSettings={customerSettings} />
            </StateSwitchContextProvider>
        );
    }

    if (role.isSupplier()) {
        return (
            <StateSwitchContextProvider>
                <SupplierOfferDetailStatusBar offer={offer} />
            </StateSwitchContextProvider>
        );
    }

    if (role.isSuperAdmin()) {
        return <AdminOfferDetailStatusBar offer={offer} />;
    }

    return null;
};
